import { render, staticRenderFns } from "./UiQr.vue?vue&type=template&id=6dfa6dda&lang=pug&"
import script from "./UiQr.vue?vue&type=script&lang=js&"
export * from "./UiQr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports